/*global BMap BMapLib*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import classnames from "classnames";
import "./index.sass";
import "./marker.sass";

import { MapStore, AppStore } from "@/store/";

import { myFn, myMap } from "@/config/";
import { init, pin, getMyLocInit } from "./initMap";
import { initEvent, initInfoBox, initControl } from "./initEvent";


myFn.init = init; // 初始化, watch 后触发
myFn.pin = pin; // 打点Marker函数挂到全局，便于 watch 后触发

@inject(stores => ({
    appStore: stores.appStore,
    mapStore: stores.mapStore,
}))
@observer
class Map extends Component {
    constructor(props) {
        super(props);
        this.$refs = {};
    }
    componentDidMount() {
        this.initMap();
    }
    initMap = () => {
        const mapStore = this.props.mapStore;
        // 初始化参数
        mapStore.defaultLoc.bLoc = new BMap.Point(mapStore.defaultLoc.lng, mapStore.defaultLoc.lat);
        mapStore.myLoc.bLoc = new BMap.Point(mapStore.myLoc.lng, mapStore.myLoc.lat);

        // 图开始初始化
        myMap.map = new BMap.Map(this.$refs.map, {
            enableHighResolution: true,
            enableMapClick: false,
        });

        initControl();

        function mapLoad(params) {
            mapStore.mapIsOk();
            myMap.map.removeEventListener('load', mapLoad);
        }
        myMap.map.addEventListener('load', mapLoad);


        // 开始初始化地图
        myMap.map.centerAndZoom(mapStore.defaultLoc.bLoc, 16);
        initEvent();
        initInfoBox();
        // 定位
        getMyLocInit();
    }

    render() {
        const stateClass = classnames({
            markerShowEmpty: this.props.appStore.appState.UseOrEmpty,
            hideMarkerText: this.props.mapStore.mapPageState.hideMarkerText,
        });
        return (
            <div id="map" className={stateClass}>
                <div className="Bmap" ref={elm => { this.$refs.map = elm; }}> </div>
                <div id="marker_center">
                    <img src={require("./lollipop.png")} alt="" />
                </div>
            </div>
        );
    }
}


Map.wrappedComponent.propTypes = {
    appStore: PropTypes.instanceOf(AppStore).isRequired,
    mapStore: PropTypes.instanceOf(MapStore).isRequired,
};
export default Map;